import { ChatView } from '../../utils/chatView';
import ChatMobileView from '../ChatMobileView';
import ChatSidebarView from '../ChatSidebarView';
import ChatWebView from '../ChatWebView';

const chatViewConfig = {
  [ChatView.MobileView]: {
    component: ChatMobileView,
    props: {},
  },
  [ChatView.WebView]: {
    component: ChatWebView,
    props: {},
  },
  [ChatView.SidebarView]: {
    component: ChatSidebarView,
    props: {},
  },
};

export {
  chatViewConfig,
};
